export default __webpack_public_path__ + "static/media/inn-suppliers.fe46169f.png";